export default __webpack_public_path__ + "static/media/SR2030.65ceae8a.png";